export var DEPLOY_DATE = new Date('2026-10-26T15:27:59+0000');
